import { useEffect, useState, useRef } from "react";
import { generateFileUrl, userRequest } from "../../requestMethods";
import CustomGrid from "../../components/grid/CustomGrid";
import "../../global.css";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import dayjs from "dayjs";
import { getProducts } from "../../redux/apiCalls";
import { formatPricing, formatTimeYYYYMMDD } from "../../util/helper";
import { useCompany } from "../../components/context/CompanyContext";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";

export default function Campaign() {
  const location = useLocation();
  const id = location.pathname.split("/")[3];
  const [campaign, setCampaign] = useState({});
  const [inputs, setInputs] = useState({});
  const [prdsTitle1, setprdsTitle1] = useState();
  const [prdsIni, setprdsIni] = useState();
  const [selectionModel1, setSelectionModel1] = useState();
  const currentUser = useSelector((state) => state.user.currentUser);
  const [products, setProducts] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const nav = useNavigate();
  const { companyId } = useCompany();
  const [data, setDate] = useState();
  const [dataIni, setDateIni] = useState();

  useEffect(() => {
    setIsLoading(true);
    if (companyId > 0) {
      getProducts();
    }
    setIsLoading(false);
  }, [companyId]);

  const getProducts = async () => {
    try {
      setIsLoading(true);
      const res = await userRequest.get(`${companyId}/products/admin`);
      setProducts(res.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    if (id !== "new" && companyId > 0) {
      getCampaign();
    }
    setIsLoading(false);
  }, [id, companyId]);

  useEffect(() => {
    selectGrid1();
    setDate(dayjs(campaign.expiryDate).format("YYYY-MM-DD"));
    setDateIni(dayjs(campaign.expiryDate).format("YYYY-MM-DD"));
  }, [campaign]);

  const selectGrid1 = () => {
    if (campaign.products) {
      setprdsIni(campaign.products);
      setprdsTitle1(campaign.products);
      setSelectionModel1(() => campaign.products.map((item) => item));
    }
  };
  const getCampaign = async () => {
    try {
      const res = await userRequest.get(`${companyId}/campaign/${id}`);

      setCampaign(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const validate = () => {
    if (inputs.title === "" || inputs.title === undefined) {
      Swal.fire(
        "Atenção!",
        "Nome da Campanha deve ser preenchidos!",
        "warning"
      );
      return false;
    }

    return true;
  };

  const validadePrds = () => {
    if (prdsTitle1 === undefined || prdsTitle1.length <= 0) {
      Swal.fire(
        "Atenção!",
        "Você deve selecionar no mímimo um produto!",
        "warning"
      );

      return false;
    }
    return true;
  };

  const updateClick = async (event) => {
    setIsLoading(true);

    if (id !== "new") {
      Update();
    } else {
      if (validate()) {
        if (validadePrds()) {
          Inserir();
        }
      }
    }
    setIsLoading(false);
  };

  async function updateIniProducts() {
    if (prdsIni) {
      prdsIni.map(async (item) => {
        await userRequest.put(`${companyId}/products/${item}`, {
          presales: null,
        });
      });
    }
  }
  const Update = async (event) => {
    try {
      await updateIniProducts();
      const res = await userRequest.put(`${companyId}/campaign/${id}`, {
        title: inputs.title,
        subTitle: inputs.subTitle,
        products: prdsTitle1,
        expiryDate: dayjs(data).hour(23).minute(59).second(59),
      });
      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Campanha alterada com sucesso!", "success");
        nav(`../campaign`);
      } else {
        Swal.fire("Atenção!", "Erro ao alterar campanha!", "error");
      }
    } catch (error) {}
  };
  const Inserir = async () => {
    try {
      const res = await userRequest.post(`${companyId}/campaign`, {
        title: inputs.title,
        subTitle: inputs.subTitle,
        products: prdsTitle1,
        expiryDate: dayjs(data).hour(23).minute(59).second(59),
      });

      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Campanha inserido com sucesso!", "success");
        nav(`../campaign`);
      } else {
        Swal.fire("Atenção!", "Erro ao inserir Campanha!", "error");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleChange = (e) => {
    setInputs((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };
  const columns = [
    {
      field: "avatar",
      headerName: "Foto",
      headerClassName: "dataGridMuiHeader",
      align: "center",
      headerAlign: "center",
      width: 50,
      display: "flex",
      renderCell: (params) => {
        return (
          <>
            <Avatar src={generateFileUrl(params.value)} />
          </>
        );
      },
    },
    {
      field: "ref",
      type: "text",
      headerName: "Referência",
      width: 80,
      align: "center",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "title",
      type: "text",
      align: "left",
      headerName: "Produto",
      width: 250,
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "category",
      type: "text",
      headerName: "Categoria",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "subCategory",
      type: "text",
      headerName: "Sub Categoria",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "discount",
      headerName: "Preço",
      width: 100,
      align: "center",
      headerAlign: "center",
      type: "number",
      headerClassName: "dataGridMuiHeader",
      valueFormatter: (value) => {
        if (value === null) {
          return "";
        }
        return `${formatPricing(value)}`;
      },
    },
    {
      field: "percentDiscount",
      headerName: "% Desconto",
      width: 120,
      align: "center",
      headerAlign: "center",
      type: "number",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "price",
      headerName: "Preço com Desconto",
      width: 160,
      align: "center",
      headerAlign: "center",
      type: "number",
      headerClassName: "dataGridMuiHeader",
      valueFormatter: (value) => {
        if (value === null) {
          return "";
        }
        return `${formatPricing(value)}`;
      },
    },
  ];
  const handleChangeStart = (e) => {
    setDate(e.target.value);
  };
  return (
    <div className="cust-page">
      <div className="cust-title">{id !== "new" ? "Editar Campanha" : "Nova Campanha"}</div>
      <div className="cust-card">
        <div className="cust-section-header">Dados da Campanha</div>
        <div className="cust-fields">
          <div className="cust-field">
            <label className="cust-label">Nome da Campanha</label>
            <input
              type="text"
              className="cust-input"
              name="title"
              defaultValue={id !== "new" ? campaign.title || "" : ""}
              onChange={handleChange}
              maxLength="20"
            />
          </div>
          <div className="cust-field">
            <label className="cust-label">Data de Validade</label>
            <input
              type="date"
              name="expiryDate"
              value={data}
              className="cust-input"
              onChange={handleChangeStart}
            />
          </div>
        </div>
        <div style={{ padding: "16px" }}>
          <div style={{ height: 500 }}>
            {products && products.length > 0 ? (
              <CustomGrid
                gridId="campaignProducts"
                getRowId={(row) => row.productId}
                rows={products}
                columns={columns}
                checkboxSelection
                selectionModel={selectionModel1}
                onSelectionChange={(itm) => {
                  setSelectionModel1(itm);
                  setprdsTitle1(itm);
                }}
                tableHeight="500px"
              />
            ) : (
              false
            )}
          </div>
        </div>
      </div>
      <div className="cust-footer">
        <Button variant="outlined" color="secondary" size="small" onClick={() => nav(-1)}>
          Voltar
        </Button>
        {id !== "new" && campaign ? (
          <Button variant="contained" color="secondary" size="small" startIcon={<SaveIcon />} onClick={updateClick}>
            Alterar
          </Button>
        ) : (
          <Button variant="contained" color="secondary" size="small" startIcon={<SaveIcon />} onClick={updateClick}>
            Cadastrar
          </Button>
        )}
      </div>
    </div>
  );
}
